/* ADN · COLECCIÓN NR — motor #2b (fundación).
   Filtrado/orden AJAX en sitio via Section Rendering API + "Cargar más" (append).
   Progressive enhancement: sin este JS, los filtros ya funcionan por URL (#2a).
   Engancha los data-nr-* de sections/nr-collection.liquid. Un solo motor, cero Empire.
   PENDIENTE (#2b parte 2): crawler móvil full-screen, conteo en vivo, buscador >10,
   "Ver más" truncado, slider doble de precio. */
(function () {
  'use strict';

  var root = document.querySelector('[data-nr-collection]');
  if (!root || root.__nrInit) return;
  root.__nrInit = true;

  var sectionId = root.getAttribute('data-nr-section-id');
  if (!sectionId) return;

  var FILTER_SEL = 'a.nrf-chip, a.nrf-check, a.nrf-radio, a.nrf-swatch, a.nrc__active-chip, a.nrc__active-clear';
  var busy = false;

  function sectionUrl(url) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
  }

  function parseSection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-nr-collection]');
  }

  // (El formato de precio del input viejo se podó con el precio por cajas — veredicto C20; el slider formatea con toLocaleString.)

  // Histograma de precio (LIVIANO): distribución de precios de la colección completa, una sola
  // vez por colección (products.json cacheado), calculada en el navegador. NO por-filtro (sería pesado).
  var HIST_CACHE = {};
  function buildHistogram(hist, handle, min, max, onReady) {
    if (!hist || !handle) return;
    var N = 16, span = (max - min) || 1;
    function render(prices) {
      var buckets = []; for (var k = 0; k < N; k++) buckets.push(0);
      prices.forEach(function (p) { var i = Math.floor((p - min) / span * N); if (i < 0) i = 0; if (i >= N) i = N - 1; buckets[i]++; });
      var peak = Math.max.apply(null, buckets) || 1;
      hist.innerHTML = '';
      buckets.forEach(function (c, i) {
        var bar = document.createElement('span'); bar.className = 'nrf-hist__bar';
        bar.style.height = (c ? Math.max(c / peak * 100, 6) : 0) + '%';
        bar.setAttribute('data-c', Math.round(min + (i + 0.5) / N * span));
        hist.appendChild(bar);
      });
      if (onReady) onReady();
    }
    if (HIST_CACHE[handle]) { render(HIST_CACHE[handle]); return; }
    var prices = [];
    (function page(p) {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + p)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var arr = (d && d.products) || [];
          arr.forEach(function (pr) {
            var vp = (pr.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
            if (vp.length) prices.push(Math.min.apply(null, vp));
          });
          if (arr.length === 250 && p < 8) page(p + 1);
          else { HIST_CACHE[handle] = prices; render(prices); }
        })
        .catch(function () { });
    })(1);
  }

  function setBusy(on) {
    busy = on;
    var results = root.querySelector('[data-nr-results]');
    if (results) results.setAttribute('aria-busy', on ? 'true' : 'false');
    root.classList.toggle('nrc--loading', on);
  }

  // Persistencia de estado de UI de filtros (sobrevive a los swaps AJAX): por grupo, si su lista
  // larga está expandida ("Ver más") y el texto del buscador. Norma: ajustar un filtro NO mueve nada.
  var filterUiState = {};
  function nrGroupKey(el) { var g = el.closest('.nrf-group'); return (g && g.getAttribute('data-nrf-group')) || ''; }

  /* Mejora progresiva de los filtros: buscador (>10), "Ver más" truncado, slider doble.
     Corre sobre el sidebar (escritorio) Y sobre el panel del crawler (clon, móvil). */
  function enhanceFilters(scope) {
    // 1 · Buscador (typeahead) en listas checkbox de >10
    scope.querySelectorAll('.nrf-checks[data-nrf-searchable]').forEach(function (list) {
      if (list.__nrSearch) return; list.__nrSearch = true;
      var key = nrGroupKey(list);
      var box = document.createElement('div'); box.className = 'nrf-search';
      var input = document.createElement('input');
      input.type = 'text'; input.placeholder = 'Buscar…'; input.setAttribute('aria-label', 'Buscar en la lista');
      box.appendChild(input);
      list.parentNode.insertBefore(box, list);
      function applyQuery() {
        var q = input.value.trim().toLowerCase();
        list.classList.toggle('nrf-checks--searching', q.length > 0);
        list.querySelectorAll('.nrf-check').forEach(function (it) {
          var lbl = it.getAttribute('data-nrf-label') || '';
          it.classList.toggle('nrf-check--nomatch', q.length > 0 && lbl.indexOf(q) === -1);
        });
      }
      input.addEventListener('input', function () {
        (filterUiState[key] = filterUiState[key] || {}).search = input.value;
        applyQuery();
      });
      var st = filterUiState[key];
      if (st && st.search) { input.value = st.search; applyQuery(); }
    });
    // 2 · "Ver más" truncado — SOLO escritorio. En el crawler móvil las listas van completas (scroll natural del panel).
    if (!scope.closest('.nrcw')) scope.querySelectorAll('.nrf-checks').forEach(function (list) {
      if (list.__nrTrunc) return;
      var items = list.querySelectorAll('.nrf-check');
      var LIMIT = 8;
      if (items.length <= LIMIT) return;
      list.__nrTrunc = true;
      var key = nrGroupKey(list);
      for (var i = LIMIT; i < items.length; i++) items[i].classList.add('nrf-check--hidden');
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'nrf-more';
      var extra = items.length - LIMIT;
      function paintBtn() { btn.textContent = list.classList.contains('nrf-checks--expanded') ? 'Ver menos' : ('Ver más (+' + extra + ')'); }
      if ((filterUiState[key] || {}).expanded) list.classList.add('nrf-checks--expanded');
      btn.addEventListener('click', function () {
        list.classList.toggle('nrf-checks--expanded');
        (filterUiState[key] = filterUiState[key] || {}).expanded = list.classList.contains('nrf-checks--expanded');
        paintBtn();
      });
      list.parentNode.insertBefore(btn, list.nextSibling);
      paintBtn();
    });
    // 3 · Precio: slider doble + histograma + lectura Desde/Hasta (SIN cajas de texto → sin desbordes)
    scope.querySelectorAll('.nrf-price[data-nrf-price]').forEach(function (el) {
      if (el.__nrSlider) return; el.__nrSlider = true;
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var max = parseInt(el.getAttribute('data-max'), 10) || 100;
      if (max <= min) return;
      var gteName = el.getAttribute('data-gte'), lteName = el.getAttribute('data-lte');
      var base = el.getAttribute('data-base') || location.pathname;
      var handle = el.getAttribute('data-handle');
      var inCrawler = !!el.closest('.nrcw');
      var curLo = parseInt(el.getAttribute('data-cur-min'), 10); if (isNaN(curLo)) curLo = min;
      var curHi = parseInt(el.getAttribute('data-cur-max'), 10); if (isNaN(curHi)) curHi = max;
      var ui = document.createElement('div'); ui.className = 'nrf-priceui';
      ui.innerHTML =
        '<div class="nrf-hist" aria-hidden="true"></div>' +
        '<div class="nrf-slider"><div class="nrf-slider__track"><div class="nrf-slider__fill"></div></div>' +
        '<input type="range" class="nrf-slider__r nrf-slider__lo" aria-label="Precio mínimo" min="' + min + '" max="' + max + '" value="' + curLo + '">' +
        '<input type="range" class="nrf-slider__r nrf-slider__hi" aria-label="Precio máximo" min="' + min + '" max="' + max + '" value="' + curHi + '"></div>';
      el.insertBefore(ui, el.querySelector('.nrf-price__readout'));
      var rlo = ui.querySelector('.nrf-slider__lo'), rhi = ui.querySelector('.nrf-slider__hi'),
          fill = ui.querySelector('.nrf-slider__fill'), hist = ui.querySelector('.nrf-hist');
      var roLo = el.querySelector('[data-nrf-ro-lo]'), roHi = el.querySelector('[data-nrf-ro-hi]');
      /* V5: en 0 resultados el histograma pintaría la distribución completa de la colección → incoherente; se oculta. */
      if (!root.querySelector('[data-nr-grid]')) hist.hidden = true;
      function pct(v) { return (v - min) / (max - min) * 100; }
      function paint() {
        var a = Math.min(+rlo.value, +rhi.value), b = Math.max(+rlo.value, +rhi.value);
        fill.style.left = pct(a) + '%'; fill.style.right = (100 - pct(b)) + '%';
        if (roLo) roLo.textContent = '$' + Number(a).toLocaleString('es-CO');
        if (roHi) roHi.textContent = '$' + Number(b).toLocaleString('es-CO');
        /* aria del range (lote aria C12): el valor anunciado = el precio formateado */
        rlo.setAttribute('aria-valuetext', '$' + Number(a).toLocaleString('es-CO'));
        rhi.setAttribute('aria-valuetext', '$' + Number(b).toLocaleString('es-CO'));
        hist.querySelectorAll('.nrf-hist__bar').forEach(function (bar) {
          var c = +bar.getAttribute('data-c'); bar.classList.toggle('is-out', c < a || c > b);
        });
      }
      function commit() {
        var a = Math.min(+rlo.value, +rhi.value), b = Math.max(+rlo.value, +rhi.value);
        var gte = a > min ? a : '', lte = b < max ? b : '';
        if (inCrawler) {
          el.dispatchEvent(new CustomEvent('nr:price', { bubbles: true, detail: { gteName: gteName, gte: gte, lteName: lteName, lte: lte } }));
        } else {
          var p = new URLSearchParams();
          el.querySelectorAll('[data-nrf-keep]').forEach(function (h) { if (h.value !== '') p.append(h.name, h.value); });
          if (gte !== '') p.append(gteName, gte);
          if (lte !== '') p.append(lteName, lte);
          var qs = p.toString();
          applyUrl(base + (qs ? '?' + qs : ''));
        }
      }
      rlo.addEventListener('input', function () { if (+rlo.value > +rhi.value) rlo.value = rhi.value; paint(); });
      rhi.addEventListener('input', function () { if (+rhi.value < +rlo.value) rhi.value = rlo.value; paint(); });
      rlo.addEventListener('change', commit);
      rhi.addEventListener('change', commit);

      // Arrastre "agarra el thumb más cercano": pointerdown en CUALQUIER parte del riel toma el
      // handle más próximo y lo arrastra siguiendo el dedo/cursor. Área táctil grande (44px) → no
      // hay que atinarle al puntico ni pelear con el borde. Los inputs nativos siguen para teclado.
      var slider = ui.querySelector('.nrf-slider'), THUMB = 18, dragK = null;
      function valFromX(clientX) {
        var r = slider.getBoundingClientRect(), usable = r.width - THUMB;
        var t = usable > 0 ? (clientX - r.left - THUMB / 2) / usable : 0;
        t = t < 0 ? 0 : t > 1 ? 1 : t;
        return Math.round(min + t * (max - min));
      }
      function setActive(v) {
        if (dragK === 'lo') rlo.value = Math.min(v, +rhi.value);
        else rhi.value = Math.max(v, +rlo.value);
        paint();
      }
      slider.addEventListener('pointerdown', function (e) {
        var v = valFromX(e.clientX), dLo = Math.abs(v - +rlo.value), dHi = Math.abs(v - +rhi.value);
        dragK = (dLo < dHi || (dLo === dHi && v < +rlo.value)) ? 'lo' : 'hi';
        (dragK === 'lo' ? rlo : rhi).focus();
        setActive(v);
        try { slider.setPointerCapture(e.pointerId); } catch (_e) {}
        e.preventDefault();
      });
      slider.addEventListener('pointermove', function (e) {
        if (dragK == null) return;
        setActive(valFromX(e.clientX));
        e.preventDefault();
      });
      function endDrag() { if (dragK == null) return; dragK = null; commit(); }
      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);

      paint();
      /* H1 (auditoría del embudo a 390px, Ago 1): el histograma paginaba products.json AUNQUE su
         panel no estuviera renderizado. En móvil el sidebar es `display:none` y el crawler nace
         cerrado, así que ese costo se pagaba entero para 16 barras que nadie podía ver: medido en
         vivo en /collections/promocion = 2 peticiones · 211,8 KB por el cable · 4.451 KB a parsear ·
         510 ms de tareas largas, contra 99,7 KB del HTML de la página completa.
         Ahora solo se construye si el elemento TIENE layout (`getClientRects`, que es 0 dentro de
         cualquier `display:none`); si no, queda pendiente y lo dispara openCrawler() al abrir —
         que es cuando el usuario de verdad pidió los filtros. */
      if (!hist.hidden) {
        if (hist.getClientRects().length) buildHistogram(hist, handle, min, max, paint);
        else hist.__nrHistPend = function () { buildHistogram(hist, handle, min, max, paint); };
      }
    });
  }

  /* Dispara los histogramas que nacieron sin layout dentro de un contenedor que acaba de mostrarse. */
  function flushHist(scope) {
    if (!scope) return;
    scope.querySelectorAll('.nrf-hist').forEach(function (h) {
      var f = h.__nrHistPend; if (!f) return;
      h.__nrHistPend = null; f();
    });
  }

  /* Aplica una URL de filtro/orden: reemplaza el interior de la sección con el render nuevo.
     Devuelve false si el motor está ocupado (el caller decide reintentar o navegar duro); true si arrancó. */
  function applyUrl(url, push) {
    if (busy) return false;
    setBusy(true);
    fetch(sectionUrl(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = parseSection(html);
        if (!fresh) { window.location.href = url; return; }
        root.innerHTML = fresh.innerHTML;
        /* pushState ANTES de restoreActiveFromUrl: la reconstrucción R-15 lee location.search y con
           el orden viejo leía la URL ANTERIOR → chips FANTASMA tras «Limpiar todo» (había que darle
           dos veces — bug cazado por Ricardo, sesión F parte 9). */
        if (push !== false) history.pushState({ nrCollection: true }, '', url);
        var _sb = root.querySelector('[data-nr-filters]');
        if (_sb) enhanceFilters(_sb);
        restoreActiveFromUrl();
        /* Ancla del scroll = el GRID (no la columna completa): las bandas de El Ideal viven arriba
           de la grilla y no deben quedarse con el viewport al re-filtrar. */
        var top = root.querySelector('[data-nr-grid]') || root.querySelector('[data-nr-results]');
        if (top && top.getBoundingClientRect().top < 0) {
          /* C22: respetar prefers-reduced-motion */
          var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
          top.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        }
        root.dispatchEvent(new CustomEvent('nr:collection:updated', { bubbles: true }));
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { setBusy(false); });
    return true;
  }

  /* Hook público: el quiz El Ideal (nr-ideal.js) reusa este motor para su relajación de filtros. */
  root.__nrApplyUrl = applyUrl;

  /* Con 0 resultados Shopify NO devuelve active_values (R-15) → el render llega SIN chips activos
     y el estado vacío cae en la rama "sin filtros" aunque la URL traiga filtros. Reconstruye los
     chips desde la URL (quitar uno = la URL sin ese parámetro) y corrige el CTA del vacío a
     "Limpiar filtros". Con resultados >0 el render nativo trae los chips y esto no hace nada. */
  function restoreActiveFromUrl() {
    if (root.querySelector('.nrc__active-chip')) return;
    var sp = new URLSearchParams(location.search);
    var params = [];
    sp.forEach(function (v, k) { if (k.indexOf('filter.') === 0) params.push([k, v]); });
    if (!params.length) return;
    var xIco = '<svg class="nr-ico" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="#nr-x"></use></svg>';
    var bar = root.querySelector('.nrc__bar');
    if (bar && !bar.querySelector('.nrc__active')) {
      var wrap = document.createElement('div');
      wrap.className = 'nrc__active';
      params.forEach(function (kv) {
        var rest = new URLSearchParams(location.search);
        var vals = rest.getAll(kv[0]).filter(function (x) { return x !== kv[1]; });
        rest.delete(kv[0]); vals.forEach(function (x) { rest.append(kv[0], x); });
        rest.delete('section_id'); rest.delete('page');
        var a = document.createElement('a');
        a.className = 'nrc__active-chip';
        a.href = location.pathname + (rest.toString() ? '?' + rest.toString() : '');
        a.innerHTML = escapeHtmlGlobal(kv[0].indexOf('filter.v.price') === 0 ? 'Precio' : kv[1]) + ' ' + xIco;
        wrap.appendChild(a);
      });
      var clear = document.createElement('a');
      clear.className = 'nrc__active-clear'; clear.href = location.pathname; clear.textContent = 'Limpiar todo';
      wrap.appendChild(clear);
      bar.appendChild(wrap);
    }
    var cta = root.querySelector('.nrc__empty-cta');
    if (cta) { cta.innerHTML = '<span>Limpiar filtros</span>'; cta.setAttribute('href', location.pathname); }
  }
  function escapeHtmlGlobal(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  restoreActiveFromUrl();

  /* "Cargar más": trae la página siguiente y AÑADE las cards (no reemplaza). */
  /* ---------- Persistencia de paginación + scroll (Solución 2) ----------
     La URL NUNCA lleva ?page → el back/refresh no aterriza en una página profunda. El acumulado
     (nº de productos), el scroll y el producto clicado viven en sessionStorage (por colección+filtros,
     sin page) y se restauran al VOLVER (back) o REFRESCAR — no en una visita fresca por link. */
  function stateKey() {
    var p = new URLSearchParams(location.search);
    p.delete('page'); p.delete('section_id'); p.delete('preview_theme_id');
    var q = p.toString();
    return 'nrcoll:' + location.pathname + (q ? '?' + q : '');
  }
  function loadStateRaw() {
    try { var s = sessionStorage.getItem(stateKey()); return s ? JSON.parse(s) : null; } catch (e) { return null; }
  }
  function loadState() {
    var st = loadStateRaw();
    if (!st) return null;
    if (st.t && (Date.now() - st.t) > 1800000) { try { sessionStorage.removeItem(stateKey()); } catch (e) {} return null; } // 30 min
    return st;
  }
  function gridCount() { var g = root.querySelector('[data-nr-grid]'); return g ? g.querySelectorAll('.nrcp').length : 0; }
  function saveState(extra) {
    try {
      if (!root.querySelector('[data-nr-grid]')) return;
      var prev = loadStateRaw() || {};
      sessionStorage.setItem(stateKey(), JSON.stringify({
        count: Math.max(gridCount(), prev.count || 0),
        y: window.scrollY || window.pageYOffset || 0,
        href: (extra && extra.href) || prev.href || null,
        t: Date.now()
      }));
    } catch (e) {}
  }

  /* Trae la página siguiente y AÑADE las cards; devuelve el botón "más" nuevo (o null). */
  function appendPage(url) {
    return fetch(sectionUrl(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = parseSection(html);
        var grid = root.querySelector('[data-nr-grid]');
        var newGrid = fresh && fresh.querySelector('[data-nr-grid]');
        if (!grid || !newGrid) throw new Error('nr-nogrid');
        var frag = document.createDocumentFragment();
        while (newGrid.firstElementChild) frag.appendChild(newGrid.firstElementChild);
        grid.appendChild(frag);
        var oldMore = root.querySelector('[data-nr-more]');
        var newMore = fresh.querySelector('[data-nr-more]');
        if (oldMore) { if (newMore) oldMore.replaceWith(newMore); else oldMore.remove(); }
        root.dispatchEvent(new CustomEvent('nr:collection:appended', { bubbles: true }));
        return root.querySelector('[data-nr-more-btn]');
      });
  }

  function loadMore(btn) {
    if (busy) return;
    var url = btn.getAttribute('href');
    if (!url) return;
    setBusy(true);
    btn.classList.add('is-loading');
    // A propósito NO hay history.replaceState(?page=N): la URL queda limpia (Solución 2).
    appendPage(url)
      .then(function () { saveState(); })
      .catch(function () { window.location.href = url; })
      .finally(function () { setBusy(false); });
  }

  /* Restaura acumulado + scroll al VOLVER (back) o REFRESCAR; en una visita fresca (link) no restaura. */
  function restoreState() {
    var navType = '';
    try { var nav = performance.getEntriesByType('navigation')[0]; navType = nav ? nav.type : ''; } catch (e) {}
    if (navType === 'navigate') return; // visita fresca intencional → sin restaurar
    var st = loadState();
    if (!st || !st.count || st.count <= gridCount()) { scrollToSaved(st); return; }
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    setBusy(true);
    var guard = 0;
    (function step() {
      var btn = root.querySelector('[data-nr-more-btn]');
      if (gridCount() >= st.count || !btn || guard++ > 40) { setBusy(false); scrollToSaved(st); return; }
      appendPage(btn.getAttribute('href')).then(step).catch(function () { setBusy(false); scrollToSaved(st); });
    })();
  }
  function scrollToSaved(st) {
    if (!st) return;
    requestAnimationFrame(function () {
      var target = null;
      if (st.href) {
        var cards = root.querySelectorAll('[data-nr-grid] .nrcp');
        for (var i = 0; i < cards.length; i++) { if (cards[i].getAttribute('href') === st.href) { target = cards[i]; break; } }
      }
      if (target) target.scrollIntoView({ block: 'center' });
      else if (st.y != null) window.scrollTo(0, st.y);
    });
  }

  /* Delegación de clicks (sobre root, que no se reemplaza). */
  root.addEventListener('click', function (e) {
    // Guarda el estado (producto clicado + scroll + acumulado) ANTES de ir a la PDP → restaurar al volver.
    var card = e.target.closest('[data-nr-grid] .nrcp');
    if (card) saveState({ href: card.getAttribute('href') });

    var more = e.target.closest('[data-nr-more-btn]');
    if (more) { e.preventDefault(); loadMore(more); return; }

    var link = e.target.closest(FILTER_SEL);
    if (link && root.contains(link)) {
      e.preventDefault();
      // Ordenar debe CONSERVAR los filtros activos: se parte del URL actual y solo se cambia sort_by
      // (el href del sort es un fallback sin-JS; aquí no dependemos de él). Se reinicia la paginación.
      if (link.hasAttribute('data-nrf-sort')) {
        var sp = new URLSearchParams(location.search);
        sp.delete('section_id'); sp.delete('page');
        sp.set('sort_by', link.getAttribute('data-nrf-sort'));
        var q = sp.toString();
        applyUrl(location.pathname + (q ? '?' + q : ''));
      } else {
        var href = link.getAttribute('href');
        if (href) applyUrl(href);
      }
    }
  });

  /* ---------- Crawler móvil (selección diferida + conteo en vivo) ---------- */
  var trigger = root.querySelector('[data-nr-filters-trigger]');
  var sidebar = root.querySelector('[data-nr-filters]');
  if (trigger && sidebar) {
    root.classList.add('nrc--js');
    trigger.hidden = false;

    var overlay = null, railEl = null, paneEl = null, seeEl = null, pending = null, activeGroup = 0, countTimer = null, countReq = 0;

    /* V4 · orden vigente por defecto: se captura del render APLICADO (carga inicial + swaps de
       applyUrl), NUNCA del sidebar vivo — refreshCounts lo reescribe con el estado PENDIENTE y
       marcaría un sort aún no aplicado (bug cazado en code-review sesión F). */
    var defaultSort = null;
    function captureDefaultSort() {
      var d = root.querySelector('[data-nr-filters] [data-nrf-sort].is-on');
      if (d) defaultSort = d.getAttribute('data-nrf-sort');
    }
    captureDefaultSort();
    root.addEventListener('nr:collection:updated', captureDefaultSort);

    function pendingParams() {
      // delete('page'): aplicar filtros SIEMPRE empieza en página 1, nunca hereda una página profunda.
      var p = new URLSearchParams(location.search); p.delete('section_id'); p.delete('page'); return p;
    }
    function pHas(p, v) { return pending.getAll(p).indexOf(v) !== -1; }
    function pToggle(p, v) {
      if (pHas(p, v)) {
        var vals = pending.getAll(p).filter(function (x) { return x !== v; });
        pending.delete(p); vals.forEach(function (x) { pending.append(p, x); });
      } else { pending.append(p, v); }
    }
    function groups() { var sb = root.querySelector('[data-nr-filters]'); return sb ? Array.prototype.slice.call(sb.querySelectorAll('.nrf-group')) : []; }
    function groupName(g) {
      var h = g.querySelector('.nrf-group__head'); if (!h) return '';
      var cnt = h.querySelector('.nrf-group__cnt'); var t = h.textContent;
      if (cnt) t = t.replace(cnt.textContent, ''); return t.trim();
    }
    function pendingCountForGroup(g) {
      var n = 0;
      g.querySelectorAll('[data-nrf-param]').forEach(function (el) {
        if (pHas(el.getAttribute('data-nrf-param'), el.getAttribute('data-nrf-value'))) n++;
      });
      return n;
    }
    function currentCount() {
      var g = root.querySelector('[data-nr-grid]');
      return g ? (parseInt(g.getAttribute('data-nr-count'), 10) || 0) : 0;
    }
    function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function build() {
      overlay = document.createElement('div');
      overlay.className = 'nrcw';
      overlay.innerHTML =
        '<div class="nrcw__scrim" data-nrcw-close></div>' +
        '<div class="nrcw__panel" role="dialog" aria-modal="true" aria-label="Filtrar y ordenar">' +
          '<div class="nrcw__head"><p class="nrcw__title nr-title-compact">Filtros</p>' +
            '<button class="nrcw__x" data-nrcw-close type="button" aria-label="Cerrar">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:100%;height:100%" aria-hidden="true" focusable="false"><use href="#nr-x"></use></svg></button></div>' +
          '<div class="nrcw__body"><div class="nrcw__rail"></div><div class="nrcw__pane"></div></div>' +
          '<div class="nrcw__foot"><button class="nrcw__clear" type="button" data-nrcw-clear>Limpiar todo</button>' +
            '<button class="nrcw__see" type="button" data-nrcw-see></button></div>' +
        '</div>';
      railEl = overlay.querySelector('.nrcw__rail');
      paneEl = overlay.querySelector('.nrcw__pane');
      paneEl.setAttribute('tabindex', '-1'); /* ancla de foco de respaldo (el trap exige el foco DENTRO del diálogo) */
      seeEl = overlay.querySelector('.nrcw__see');
      document.body.appendChild(overlay);
      overlay.addEventListener('click', onOverlayClick);
      /* Focus trap (lote aria C12, patrón H7 del lightbox): Tab atrapado dentro del crawler.
         OJO: a[href] estricto — [href] a secas matchea los <use href="#nr-…"> de los SVG
         (no enfocables) y el trap nunca envuelve (bug cazado en vivo, sesión F). */
      overlay.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var all = overlay.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var f = [];
        for (var i = 0; i < all.length; i++) {
          if (all[i].disabled) continue;
          var cs = getComputedStyle(all[i]);
          if (cs.display === 'none' || cs.visibility === 'hidden') continue;
          f.push(all[i]);
        }
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      overlay.addEventListener('nr:price', function (e) {
        var d = e.detail;
        if (d.gte === '') pending.delete(d.gteName); else pending.set(d.gteName, d.gte);
        if (d.lte === '') pending.delete(d.lteName); else pending.set(d.lteName, d.lte);
        refreshCounts();
      });
    }
    function renderRail() {
      railEl.innerHTML = '';
      groups().forEach(function (g, i) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'nrcw__tab' + (i === activeGroup ? ' is-on' : '');
        btn.setAttribute('data-nrcw-tab', i);
        var n = pendingCountForGroup(g);
        btn.innerHTML = '<span>' + escapeHtml(groupName(g)) + '</span>' + (n > 0 ? '<span class="nrcw__tab-cnt">' + n + '</span>' : '');
        railEl.appendChild(btn);
      });
    }
    function renderPane() {
      var g = groups()[activeGroup]; paneEl.innerHTML = ''; if (!g) return;
      var h = document.createElement('p'); h.className = 'nrcw__pane-h nr-eyebrow'; h.textContent = groupName(g); paneEl.appendChild(h);
      var body = g.querySelector('.nrf-group__body').cloneNode(true);
      // Evita DUPLICAR mejoras: el clon viene del sidebar ya enriquecido (buscador, "Ver más",
      // slider). Se quitan y enhanceFilters las re-inyecta una sola vez sobre el panel.
      body.querySelectorAll('.nrf-search, .nrf-more, .nrf-priceui').forEach(function (el) { el.remove(); });
      body.querySelectorAll('.nrf-checks').forEach(function (l) { l.classList.remove('nrf-checks--searching', 'nrf-checks--expanded'); });
      body.querySelectorAll('.nrf-check--hidden, .nrf-check--nomatch').forEach(function (el) { el.classList.remove('nrf-check--hidden', 'nrf-check--nomatch'); });
      body.querySelectorAll('[data-nrf-param]').forEach(function (el) {
        var on = pHas(el.getAttribute('data-nrf-param'), el.getAttribute('data-nrf-value'));
        el.classList.toggle('is-on', on);
        if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
      });
      /* V4: el crawler marca SIEMPRE el orden vigente — si la URL no trae sort_by, rige el
         default de la colección (capturado del render APLICADO, ver captureDefaultSort). */
      var curSort = pending.get('sort_by') || defaultSort;
      body.querySelectorAll('[data-nrf-sort]').forEach(function (el) {
        var on = curSort === el.getAttribute('data-nrf-sort');
        el.classList.toggle('is-on', on);
        if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
      });
      body.querySelectorAll('.nrf-price[data-nrf-price]').forEach(function (pel) {
        var g = pending.get(pel.getAttribute('data-gte'));
        var l = pending.get(pel.getAttribute('data-lte'));
        pel.setAttribute('data-cur-min', g != null ? g : '');
        pel.setAttribute('data-cur-max', l != null ? l : '');
      });
      paneEl.appendChild(body);
      enhanceFilters(paneEl);
      /* Re-ancla del foco: renderPane DESTRUYE el nodo enfocado → sin esto el foco cae a <body>
         y el trap deja de ver los Tab (bug cazado en code-review sesión F). */
      if (overlay.classList.contains('is-open') && !overlay.contains(document.activeElement)) {
        try { paneEl.focus({ preventScroll: true }); } catch (_e) { paneEl.focus(); }
      }
    }
    /* Re-enfoca en el pane recién pintado el control equivalente al tapeado (el nodo viejo murió con renderPane). */
    function refocusPane(attr, value, param) {
      var els = paneEl.querySelectorAll('[' + attr + ']');
      for (var i = 0; i < els.length; i++) {
        if (els[i].getAttribute(attr) === value && (!param || els[i].getAttribute('data-nrf-param') === param)) { els[i].focus(); return; }
      }
    }
    function refreshCounts() {
      railEl.querySelectorAll('.nrcw__tab').forEach(function (btn, i) {
        var n = pendingCountForGroup(groups()[i]); var badge = btn.querySelector('.nrcw__tab-cnt');
        if (n > 0) { if (badge) badge.textContent = n; else { var b = document.createElement('span'); b.className = 'nrcw__tab-cnt'; b.textContent = n; btn.appendChild(b); } }
        else if (badge) badge.remove();
      });
      /* H5 (auditoría del embudo a 390px, Ago 2): aquí vivía `seeEl.disabled = true`.
         Medido en vivo en /collections/all: el CTA quedaba MUERTO 1.000 ms tras cada tap de filtro
         —y con `opacity:1`, `cursor:pointer` y fondo negro, es decir, IDÉNTICO al estado vivo—.
         El usuario tocaba «Ver 26 productos» y no pasaba nada, sin ninguna señal de por qué.
         Se quita porque el bloqueo no protegía nada: el handler de `[data-nrcw-see]` aplica
         `pending`, que YA está actualizado en el instante del tap; el fetch de conteo solo refresca
         la ETIQUETA. Se estaba bloqueando la acción principal para cuidar un número cosmético.
         El doble-tap sigue cubierto: `closeCrawler()` corre antes y `applyUrl` tiene guarda `busy`.
         La cifra puede quedar desfasada <1 s; los filtros aplicados son siempre los correctos. */
      clearTimeout(countTimer);
      var reqId = ++countReq;
      countTimer = setTimeout(function () {
        var qs = pending.toString(); var url = location.pathname + (qs ? '?' + qs : '');
        fetch(sectionUrl(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (reqId !== countReq) return; // ignora respuestas viejas (toggles rápidos)
            var fresh = parseSection(html);
            var g = fresh && fresh.querySelector('[data-nr-grid]');
            var n = g ? (parseInt(g.getAttribute('data-nr-count'), 10) || 0) : 0;
            seeEl.textContent = 'Ver ' + n + (n === 1 ? ' producto' : ' productos'); seeEl.disabled = false;
            // REGENERAR las opciones disponibles según el estado PENDIENTE (co-ocurrencia de Shopify):
            // el fetch ya trae los filtros re-renderizados → reemplaza los grupos del sidebar y re-pinta
            // rail+pane. Así, al quitar un filtro reaparecen las opciones que se habían ocultado, sin
            // esperar a "Ver productos". Preserva la pestaña activa (por nombre) y las selecciones.
            var freshSb = fresh && fresh.querySelector('[data-nr-filters]');
            var sb = root.querySelector('[data-nr-filters]');
            if (freshSb && sb) {
              var curG = groups()[activeGroup];
              var activeName = curG ? groupName(curG) : null;
              sb.innerHTML = freshSb.innerHTML;
              enhanceFilters(sb);
              if (activeName != null) {
                var idx = groups().map(groupName).indexOf(activeName);
                activeGroup = idx >= 0 ? idx : Math.min(activeGroup, Math.max(0, groups().length - 1));
              }
              if (activeGroup < 0) activeGroup = 0;
              renderRail(); renderPane();
            }
          })
          .catch(function () { if (reqId === countReq) { seeEl.textContent = 'Ver productos'; seeEl.disabled = false; } });
      }, 280);
    }
    function openCrawler() {
      if (!overlay) build();
      pending = pendingParams();
      // Persistencia: reabrir en la MISMA pestaña donde salió (activeGroup no se resetea).
      if (activeGroup < 0 || activeGroup >= groups().length) activeGroup = 0;
      renderRail(); renderPane();
      var _cc = currentCount();
      seeEl.textContent = 'Ver ' + _cc + (_cc === 1 ? ' producto' : ' productos'); seeEl.disabled = false;
      overlay.classList.add('is-open'); document.body.classList.add('nrcw-open');
      /* H1: renderPane() corre ARRIBA, con el overlay todavía en display:none → el histograma quedó
         pendiente. Ya visible, se construye aquí (una sola vez; products.json va cacheado por colección). */
      flushHist(overlay);
      var _to = root.querySelector('[data-nr-filters-trigger]'); if (_to) _to.setAttribute('aria-expanded', 'true');
      /* Gestión de foco (patrón H7): foco a la ✕ al abrir; retorno al trigger al cerrar. */
      var _x = overlay.querySelector('.nrcw__x'); if (_x) _x.focus();
    }
    function closeCrawler() {
      if (!overlay || !overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open'); document.body.classList.remove('nrcw-open');
      var _tc = root.querySelector('[data-nr-filters-trigger]');
      if (_tc) { _tc.setAttribute('aria-expanded', 'false'); if (_tc.focus) _tc.focus(); }
    }
    function onOverlayClick(e) {
      if (e.target.closest('[data-nrcw-close]')) { e.preventDefault(); closeCrawler(); return; }
      var tab = e.target.closest('[data-nrcw-tab]');
      if (tab) {
        activeGroup = parseInt(tab.getAttribute('data-nrcw-tab'), 10); renderRail(); renderPane();
        var nt = railEl.querySelector('[data-nrcw-tab="' + activeGroup + '"]'); if (nt) nt.focus();
        return;
      }
      if (e.target.closest('[data-nrcw-clear]')) {
        e.preventDefault(); var s = pending.get('sort_by');
        pending = new URLSearchParams(); if (s) pending.set('sort_by', s);
        renderRail(); renderPane(); refreshCounts(); return;
      }
      if (e.target.closest('[data-nrcw-see]')) {
        e.preventDefault(); var qs = pending.toString(); closeCrawler();
        applyUrl(location.pathname + (qs ? '?' + qs : '')); return;
      }
      var sortEl = e.target.closest('[data-nrf-sort]');
      if (sortEl) {
        e.preventDefault(); var sv = sortEl.getAttribute('data-nrf-sort');
        pending.set('sort_by', sv); renderPane(); refreshCounts();
        refocusPane('data-nrf-sort', sv); return;
      }
      var opt = e.target.closest('[data-nrf-param]');
      if (opt) {
        e.preventDefault(); var op = opt.getAttribute('data-nrf-param'), ov2 = opt.getAttribute('data-nrf-value');
        pToggle(op, ov2); renderPane(); refreshCounts();
        refocusPane('data-nrf-value', ov2, op); return;
      }
    }
    root.addEventListener('click', function (e) { if (e.target.closest('[data-nr-filters-trigger]')) { e.preventDefault(); openCrawler(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCrawler(); });
  }

  /* Mejora inicial del sidebar (escritorio / fallback móvil). */
  var _initSidebar = root.querySelector('[data-nr-filters]');
  if (_initSidebar) enhanceFilters(_initSidebar);

  /* Botón atrás/adelante del navegador. */
  window.addEventListener('popstate', function () {
    applyUrl(window.location.href, false);
  });

  /* Solución 2 — restaurar acumulado + scroll al volver/refrescar; guardar al salir.
     scrollRestoration=manual: el navegador no salta a una posición vieja antes de que carguemos. */
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  var _restored = false;
  window.addEventListener('pagehide', function () { saveState(); });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted || _restored) return; // bfcache = DOM intacto; guard = una sola vez
    _restored = true;
    restoreState();
  });
})();
